import t from '@jetshop/intl';
import { SelectDropdown } from '@jetshop/ui/Select';
import SortOrder from '@jetshop/ui/SortOrder/SortOrder';
import * as React from 'react';
const SortOrderDropdown = ({ sortOrders }) => {
    return (React.createElement(SortOrder, { sortOrders: sortOrders }, ({ changeSortOrder, direction, sortOrder, mappedSortOrder }) => (React.createElement(SelectDropdown, { items: mappedSortOrder, title: t('Sort By'), className: "sortBy", selectedItem: mappedSortOrder.find(item => item.direction === direction && item.value === sortOrder), onChange: (item) => changeSortOrder(item.value, item.direction) }))));
};
export default SortOrderDropdown;
//# sourceMappingURL=SortOrderDropdown.js.map